<div class="heatmap">
    <h2 class="">{{mapTitle}} <span class="title-date">{{currentDate | date : "longDate"}}</span></h2>
    <div class="eia-chart-manual-subtitle">degrees Fahrenheit</div>
    <div id="controls" class="controls">
        <button (click)="playDailyAnimation()" class="play active">Play</button>
        <button class="pause active" id="stopRestart">Pause</button>
    </div>
    <div class="jvectormap">
        <div id="{{mapId}}" class="container"></div>
    </div>
</div>
<!-- begin legend -->
<app-map-legend [heatMapColors]="heatMapColors"></app-map-legend>
<!-- end legend -->

<nouislider [min]="0" [max]="dataCount" [step]="1" [ngModel]="currentIteration"
            [connect]="true" (change)="iterateMap($event)"
            [disabled]="dataCount <= 0"></nouislider>


// WEBPACK FOOTER //
// ./src/app/share-modules/eia-charts/map-daily-animation/map-daily-animation.component.html